import { StudyFormContext } from './StudyFormContext';
import { useContext } from 'react';

export const useStudyFormContext = () => {
  const studyFormContext = useContext(StudyFormContext);

  if (!studyFormContext) {
    throw new Error('useStudyForm must be used within a StudyFormProvider');
  }

  return {
    ...studyFormContext,
  };
};
